<div class="layout">
  <header>
    <div class="left">
      <app-svg-icon name="logo2" [title]="'navigation.logo' | translate" />
      <app-view-switcher />
    </div>
    <div class="right">
      <app-header />
    </div>
  </header>

  <main>
    <router-outlet />
  </main>
</div>

<app-modal-layout />
<app-dropdown-layout />
<app-notify-queue />
@if (startModalClosed) {
  <app-google-onetap/>
}
